import { ReactNode } from 'react';

interface PageHeaderProps {
  eyebrow: string;
  title: ReactNode;
  description?: string;
  children?: ReactNode;
}

/** Consistent top-of-page hero for every inner route (Services, About, FAQ, Contact, ...). */
function PageHeader({ eyebrow, title, description, children }: PageHeaderProps) {
  return (
    <section className="page-header">
      <div className="container">
        <span className="section-label">{eyebrow}</span>
        <h1 className="page-header-title">{title}</h1>
        {description && <p className="page-header-desc">{description}</p>}
        {children}
        <div className="page-header-rule" />
      </div>
    </section>
  );
}

export default PageHeader;
